<template>
  <svg
    id="Capa_1"
    :viewBox="viewbox"
    :height="height"
    :width="width"
    data-name="Capa 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <line class="cls-1" x1="24.6" y1="10.23" x2="24.6" y2="8.26" />
    <polyline
      class="cls-1"
      points="24.6 3.01 14.9 0.5 3.49 2.84 3.49 13.28 6.47 14.64"
    />
    <line class="cls-1" x1="14.9" y1="0.5" x2="14.9" y2="5.32" />
    <line class="cls-1" x1="12.73" y1="9.23" x2="12.73" y2="5.85" />
    <polyline
      class="cls-1"
      points="21.06 9.29 27.71 7.09 24.6 3.01 12.72 5.85 3.49 2.84 0.58 6.19 3.49 6.19"
    />
    <line class="cls-1" x1="12.73" y1="5.99" x2="14.72" y2="8.84" />
    <polygon
      class="cls-1"
      points="6.54 19.83 15.64 23.98 26.24 20.54 26.24 10.8 17.41 8.39 6.57 10.5 6.54 19.83"
    />
    <polyline class="cls-1" points="6.57 10.5 15.6 13.64 26.24 10.8" />
    <line class="cls-1" x1="15.6" y1="13.65" x2="15.64" y2="23.98" />
    <polyline class="cls-1" points="9.41 21.1 9.41 11.54 20.45 9.3" />
    <polyline class="cls-1" points="12.29 22.34 12.29 12.47 23.3 10" />
    <polyline class="cls-2" points="19.18 22.78 19.18 12.78 10.28 9.79" />
    <polyline class="cls-2" points="22.56 21.67 22.56 11.77 13.86 9.1" />
    <polyline class="cls-2" points="6.47 16.92 15.57 20.5 26.2 17.49" />
    <polyline class="cls-2" points="6.47 13.75 15.64 17.09 26.24 14.15" />
    <polyline
      class="cls-2"
      points="6.54 19.33 3.93 20.07 3.93 22.11 15.64 27.73 29.42 22.74 29.42 20.43 26.17 19.77"
    />
    <polyline class="cls-2" points="3.93 20.07 15.6 25.55 29.42 20.43" />
    <line class="cls-2" x1="15.64" y1="27.73" x2="15.64" y2="25.55" />
    <polyline
      class="cls-2"
      points="4.23 22.18 4.23 23.85 6.04 24.72 8.85 24.48"
    />
    <polyline
      class="cls-2"
      points="8.81 24.52 8.81 26.19 10.62 27.06 13.43 26.82 13.8 26.86"
    />
    <line class="cls-2" x1="6.04" y1="24.72" x2="6.04" y2="23.14" />
    <polyline
      class="cls-2"
      points="13.39 26.62 13.39 28.5 15.44 29.5 29.15 24.32 29.15 22.81"
    />
    <line class="cls-2" x1="15.43" y1="29.5" x2="15.37" y2="27.63" />
    <line class="cls-2" x1="10.62" y1="27.06" x2="10.62" y2="25.32" />
  </svg>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["dataUser"]),
  },
  props: {
    color: {
      type: String,
      default: "#00000",
    },
    height: {
      type: Number,
      default: 30,
    },
    width: {
      type: Number,
      default: 30,
    },
    viewbox: {
      type: String,
      default: "0 -3 30 30",
    },
  },
};
</script>

<style scoped>
.cls-1,
.cls-2 {
  fill: none;
  stroke: #000000;
  stroke-linejoin: round;
  stroke-width: 0.5px;
}
.cls-1 {
  stroke-linecap: round;
}
</style>
